
export const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file);
    })
}

export function displayBase64Pdf(base64Pdf) {

    return `data:application/pdf;base64,${ base64Pdf }#toolbar=0&navpanes=0&scrollbar=0`;
}